import { httpClient } from '../api/httpClient';
import useAuth from './useAuth';
import { API_ENDPOINTS } from '../api/endpoints';
import { useNavigate } from "react-router-dom";
import {jwtDecode} from "jwt-decode";
import URIs from '../utils/uri'

const useRefreshToken = () => {
    const { setAuth } = useAuth();
    const navigate = useNavigate();

    const refresh = async () => {
        try{
            const response = await httpClient.get(API_ENDPOINTS.REFRESH, {
                withCredentials: true
            });
            setAuth(prev => {
                const accessToken = response.data.data.accessToken;
                let decodedToken = jwtDecode(accessToken)
                const roles = decodedToken.roles
                return { ...prev, roles: roles, accessToken: accessToken }
            });
            return response.data.data.accessToken;

        }catch (err) {
            console.log("Err: ", err)
            navigate(URIs.LOGIN)
        }
    }
    return refresh;
};

export default useRefreshToken;